import { register, init } from "marko/dist/runtime/components/index.js";
import "./style.scss";
import "./logo.svg";
import "../../components/app-layout/style.scss";
import "../../components/app-layout/favicon.ico";
import "../../components/app-layout/favicon.svg";
import "../../components/app-navbar/style.scss";
import "../../components/app-navbar/logo.svg";
import "../../components/doc-search/index.marko";
import "../../components/app-user-notifications/index.marko";
import component_0 from "../../components/app-navbar/component-browser.js";
register("rZrNIi1", component_0);
import "../../components/app-footer/style.scss";
import "../../components/app-login/index.marko";
init("_fio_dashboard");